import React from 'react';
import styled from 'styled-components';

import { Codeshare, CarrierDetails } from '../../types/flight';
import { emptyFieldCharacter } from './FlightSummary';
import { iataOrFallBackToLabeledFS } from './FlightViewBody';

interface CodesharesFormProps {
  flightNumber?: string;
  operatedBy?: CarrierDetails;
  marketedBy?: Codeshare[];
}

const CodeshareDiv = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const FlexRow = styled.div`
  flex-direction: row;
  margin: 0.625rem;
`;

export const Codeshares: React.FC<CodesharesFormProps> = ({
  flightNumber,
  operatedBy,
  marketedBy,
}) => {
  return (
    <CodeshareDiv>
      {operatedBy && (
        <OperatedBy operatedBy={operatedBy} flightNumber={flightNumber} />
      )}
      <MarketedBy marketedBy={marketedBy} />
    </CodeshareDiv>
  );
};

interface OperatedByProps {
  flightNumber?: string;
  operatedBy?: CarrierDetails;
}

const OperatedBy: React.FC<OperatedByProps> = ({ operatedBy, flightNumber }) => {
  const operatedByCode = iataOrFallBackToLabeledFS(operatedBy);
  const operatedByDisplay = `${operatedByCode} (${operatedBy?.name ?? ''} ${flightNumber ?? ''})`;

  return (
    <FlexRow>
      <h3>Operated By</h3>
      <ul>
        <li key={operatedByCode}>{operatedByDisplay}</li>
      </ul>
    </FlexRow>
  );
};

interface MarketedByProps {
  marketedBy?: Codeshare[];
}

const MarketedBy: React.FC<MarketedByProps> = ({ marketedBy }) => {
  const marketedByItems = marketedBy?.map(flight => {
    const flightNumber = flight.flightNumber || emptyFieldCharacter;

    if (!flight.carrierDetails) return `Flight ${flightNumber}`;
    const name = flight.carrierDetails?.name || emptyFieldCharacter;
    const carrierDisplayCode = iataOrFallBackToLabeledFS(flight.carrierDetails);

    const marketedByDisplayName = `${carrierDisplayCode} (${name} ${flightNumber})`;

    return <li key={carrierDisplayCode}>{marketedByDisplayName}</li>;
  });

  return (
    <FlexRow>
      <h3>Marketed By</h3>
      {marketedBy?.length ? (
        <ul>{marketedByItems}</ul>
      ) : (
        <p>No additional airlines</p>
      )}
    </FlexRow>
  );
};